// @greenlight-spec: 28-it-dashboard-ui.md
import type { QueryClient } from '@tanstack/react-query';

import { AUDIT_LIST_KEY } from '@/components/audit/useAuditLog';

/**
 * Refreshes what a lifecycle action (pause, restore, delete, still needed) moves: the detail
 * header badge, every paginated `/apps` page (`['apps']` prefix-matches each
 * `['apps', cursor]` entry), and the audit list, so the audited row shows up
 * without a reload.
 */
export async function refreshAfterLifecycleChange(
  queryClient: QueryClient,
  appId: string,
): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: ['apps.get', appId] }),
    queryClient.invalidateQueries({ queryKey: ['apps'] }),
    queryClient.invalidateQueries({ queryKey: [AUDIT_LIST_KEY] }),
  ]);
}
